import { defineMessages } from 'react-intl';
export default defineMessages({
  emptyTableMessage: {
    id: "General.emptyTableMessage",
    defaultMessage: [{
      "type": 0,
      "value": "No content here yet"
    }]
  },
  skholeCourses: {
    id: "General.skholeCourses",
    defaultMessage: [{
      "type": 1,
      "value": "serviceNamePossessive"
    }, {
      "type": 0,
      "value": " courses"
    }]
  },
  defaultPossessiveName: {
    id: "General.serviceNamePossessive",
    defaultMessage: [{
      "type": 0,
      "value": "Skhole"
    }]
  },
  nextIconAriaLabel: {
    id: "General.nextIconAriaLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Next"
    }]
  },
  backIconAriaLabel: {
    id: "General.backIconAriaLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Previous"
    }]
  }
});